import ComingSoon from "components/ComingSoon";
import React from "react";

function Tickets() {
  return <ComingSoon />;
}

export default Tickets;
